import React, { useEffect, useRef, useState } from 'react';
import iconCalendar from '../../images/icon-calendar.svg';
import Select from '../ui/Select';
import CustomDatePicker from "../ui/DatePicker";

export default function TbmCrrStatusDetail({ tbmDetail, selectCom, selectComData, detailHandler, auth, date, setDate }: any) {
  const [selectPopup, setSelectPopup] = useState(false);
  const [datePopup, setDatePopup] = useState(false);
  const [completeTab, setCompleteTab] = useState('전체');
  const [dateView, setDateView] = useState('');
  const prodRef = useRef<any>();
  const datePopupOpen = () => { setDatePopup(!datePopup); };
  const selectHandler = (data: any) => {
    detailHandler(data);
    setSelectPopup(false);
  };
  useEffect(() => {
    let year = date.getFullYear();
    let month: number = date.getMonth() + 1;
    let day = date.getDate();
    setDateView(`${year}. ${month >= 10 ? month : '0' + month}. ${day >= 10 ? day : '0' + day}`);
  }, [date]);

  return (
    <>
      <div className='h-125 md:h-[312px] flex flex-col items-center pt-7 md:pt-[17px]'>
        {auth !== 'SRV' && <Select select={selectCom} selectPopup={selectPopup}>업체명</Select>}
        {auth === 'SRV' &&
          <div
            onClick={datePopupOpen}
            ref={prodRef}
            className='hover:cursor-pointer w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] bg-[#2F2F35] flex justify-between items-center rounded-[5px] md:rounded-[12px] mb-14 md:mb-[35px]'>
            <p className='text-14 ml-15 sm:text-15 md:text-37 sm:ml-20 md:ml-[50px] font-preBold'>날짜</p>
            <p className='text-13 sm:text-15 md:text-37 font-preLight w-170 sm:w-[210px] md:w-[525px]'>{dateView}</p>
            <img className='w-16 mr-16 md:w-[40px] md:mr-[40px]' src={iconCalendar} alt='calendar' />
          </div>}
        {datePopup
          ? <div className='absolute top-57 md:top-[142px]'>
            <CustomDatePicker date={date} setDate={setDate} setDateView={setDateView} setDatePopup={setDatePopup} prodRef={prodRef} />
          </div>
          : null}
        <div className='w-[265px] sm:w-[294px] md:w-[735px] flex items-center justify-between mt-18 md:mt-[45px]'>
          <button
            onClick={() => setCompleteTab('전체')}
            className={completeTab === '전체' ? `w-82 sm:w-88 md:w-[220px] h-32 md:h-[80px] rounded-full bg-transparent border border-point text-point text-14 md:text-35`
              : `w-82 sm:w-88 md:w-[220px] h-32 md:h-[80px] rounded-full bg-transparent border border-white text-14 md:text-35`}>전체</button>
          <button
            onClick={() => setCompleteTab('완료')}
            className={completeTab === '완료' ? `w-82 sm:w-88 md:w-[220px] h-32 md:h-[80px] rounded-full bg-transparent border border-point text-point text-14 md:text-35`
              : `w-82 sm:w-88 md:w-[220px] h-32 md:h-[80px] rounded-full bg-transparent border border-white text-14 md:text-35`}>완료</button>
          <button
            onClick={() => setCompleteTab('미완료')}
            className={completeTab === '미완료' ? `w-82 sm:w-88 md:w-[220px] h-32 md:h-[80px] rounded-full bg-transparent border border-point text-point text-14 md:text-35`
              : `w-82 sm:w-88 md:w-[220px] h-32 md:h-[80px] rounded-full bg-transparent border border-white text-14 md:text-35`}>미완료</button>
        </div>
      </div>
      <div className='h-[calc(100%-177px)] md:h-[calc(100%-442px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center '>
        <div className='mb-20 md:mb-[50px]'>
          <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-30 md:mt-[75px]'>
            <tbody>
              <tr className='bg-[#F6F7F9] h-40 sm:h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-[37px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                <td className='align-middle text-center w-83 sm:w-87'>성명</td>
                <td className='align-middle text-center w-56 sm:w-60'>작업시작</td>
                <td className='align-middle text-center w-56 sm:w-60'>작업종료</td>
                <td className='align-middle text-center w-61 sm:w-65'>TBM이수</td>
              </tr>
              {tbmDetail?.length == 0 ?
                <tr className='hover:cursor-pointer h-60 md:h-[150px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td colSpan={4} className='align-middle text-center'>조회된 데이터가 없습니다.</td>
                </tr>
                : null
              }
              {completeTab === '전체' &&
                tbmDetail?.map((detail: any, idx: number) => {
                  return (
                    <tr key={idx} className='h-55 sm:h-60 md:h-[150px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                      <td className='align-middle text-center'>{detail.userNm}</td>
                      <td className='align-middle text-center'>{detail.workStrtTime}</td>
                      <td className='align-middle text-center'>{detail.workEndTime}</td>
                      <td className='align-middle text-center'>{detail.tbmPrcsStat == '003' ? '완료' : <span className='text-point'>미완료</span>}</td>
                    </tr>
                  );
                })}
              {completeTab === '완료' &&
                tbmDetail?.filter((data: any) => data.tbmPrcsStat === '003').map((detail: any, idx: number) => {
                  return (
                    <tr key={idx} className=' h-60 md:h-[150px] text-14 md:text-35 leading-16 md:leading-[40px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                      <td className='align-middle text-center w-90'>{detail.userNm}</td>
                      <td className='align-middle text-center w-60'>{detail.workStrtTime}</td>
                      <td className='align-middle text-center w-60'>{detail.workEndTime}</td>
                      <td className='align-middle text-center w-65'>{'완료'}</td>
                    </tr>
                  );
                })}
              {completeTab === '미완료' &&
                tbmDetail?.filter((data: any) => data.tbmPrcsStat !== '003').map((detail: any, idx: number) => {
                  return (
                    <tr key={idx} className=' h-60 md:h-[150px] text-14 md:text-35  font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                      <td className='align-middle text-center w-90'>{detail.userNm}</td>
                      <td className='align-middle text-center w-60'>{detail.workStrtTime}</td>
                      <td className='align-middle text-center w-60'>{detail.workEndTime}</td>
                      <td className='align-middle text-center w-65 text-point'>{'미완료'}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

